// ============================================
// components/common/EmailVerificationWarning.js
// ============================================
import React, { useState } from 'react';
import { Alert, Button, CircularProgress, Stack } from '@mui/material';
import { authService } from '../../services/authService';
import { MESSAGES } from '../../utils/constants';

const EmailVerificationWarning = ({ show, onResendSuccess, onCheckNow }) => {
  const [resendLoading, setResendLoading] = useState(false);
  const [checkLoading, setCheckLoading] = useState(false);

  if (!show) return null;

  const handleResend = async () => {
    setResendLoading(true);
    const result = await authService.resendVerificationEmail();
    setResendLoading(false);
    
    if (result.success && onResendSuccess) {
      onResendSuccess();
    }
  };

  const handleCheckNow = async () => {
    if (!onCheckNow) return;
    setCheckLoading(true);
    try {
      await onCheckNow();
    } finally {
      setCheckLoading(false);
    }
  };

  return (
    <Alert 
      data-testid="email-verification-warning"
      severity="warning" 
      sx={{ 
        width: '100%', 
        maxWidth: 400, 
        mt: 2, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between' 
      }}
    >
      <span>{MESSAGES.EMAIL_VERIFICATION_REQUIRED}</span>
      <Stack direction="row" spacing={1} sx={{ ml: 2 }}>
        <Button 
          variant="outlined" 
          size="small" 
          onClick={handleCheckNow}
          disabled={checkLoading}
        >
          {checkLoading ? <CircularProgress size={16} color="inherit" /> : 'Check now'}
        </Button>
        <Button 
          variant="outlined" 
          size="small" 
          onClick={handleResend}
          disabled={resendLoading}
        >
          {resendLoading ? <CircularProgress size={16} color="inherit" /> : 'Resend'}
        </Button>
      </Stack>
    </Alert>
  );
};

export default EmailVerificationWarning;